import { render } from "./SponsorsView.vue?vue&type=template&id=ff3ed198"
import script from "./SponsorsView.vue?vue&type=script&lang=ts"
export * from "./SponsorsView.vue?vue&type=script&lang=ts"
script.render = render

export default script